define('modules/form_editor/views/preview_hidden',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/input_hidden'],function(require, exports, module){
  "use strict";
  var InputBase = require("./preview_base"),
      EditorState = require("../../editor/models/editorstate");
  module.exports = InputBase.extend({
    template: require("ldsh!../templates/input_hidden"),
    className: "form-group ed-panel-item input-hidden",
    helpers: function() {
      return {
        isAMP: EditorState.getAMPState()
      };
    },
  });
});

